import { FC, ReactNode } from 'react';
import classnames from 'classnames';

import { Icon } from '../icon/Icon';

import './errorMessage.scss';

type Props = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

export const ErrorMessage: FC<Props> = ({ children, className = '', testId = '' }) => {
  return (
    <div className={classnames('error-message', className)} data-test={testId}>
      <Icon name="exclamationHexagonFilled" />
      <span>{children}</span>
    </div>
  );
};
